var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.has_fantasy_tips_store
    ? _c(
        "div",
        [
          _vm.hasMatchInfoData
            ? _c("info-feed", { attrs: { parentRoute: _vm.parentRoute } })
            : _vm._e(),
          _vm._v(" "),
          _vm.is_loading
            ? _c("div", { staticClass: "fg-preloader-wrap" }, [
                _c("div", { staticClass: "fg-preloader" }),
              ])
            : !_vm.hasMatchInfoData
            ? _c("no-data-box")
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }